exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes updateSuccessAnimation{0%{transform:rotate(90deg)}to{transform:rotate(0)}}.manual-updater .custom-file .custom-file-label{color:#a4a5a7!important}.manual-updater .custom-file .custom-file-label:after{background:#6c757d!important}.manual-updater .spinner-border{height:20px;width:20px}.manual-updater .check-circle-wrapper{animation-name:updateSuccessAnimation;animation-duration:.4s}.manual-updater .check-circle-wrapper svg{stroke-width:1.5!important;color:#4466f2!important}", ""]);

// exports
